<tg-bulk-edit-progress-overlay
	[failed]="bulkProgress.failed"
	[percent]="loadingPercent"
	[phase]="loadingPhase"
	*ngIf="showProgressOverlay"
	mode="save"
></tg-bulk-edit-progress-overlay>
<div matDialogTitle>
	<div class="flex flex-row items-center justify-start">
		<div>{{ 'time.bulk-dialog-title' | translate: { count: entityCount } }}</div>
		<div class="flex-auto"></div>
		<button
			mat-icon-button
			matDialogClose
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="group"
		class="mb-3 flex flex-col space-y-8"
	>
		<mat-form-field appearance="fill">
			<mat-label>{{ 'time.select' | translate }}</mat-label>
			<input
				formControlName="name"
				matInput
				type="text"
			>
			<mat-hint>{{ 'time.bulk-hint-name' | translate }}</mat-hint>
		</mat-form-field>
		<mat-form-field
			(click)="$event.preventDefault(); openProjectPicker()"
			appearance="fill"
			class="cursor-pointer"
		>
			<mat-label translate>project.single</mat-label>
			<input
				[value]="group.value.project | defaultEntityTranslate: 'project' : 'project.none'"
				class="cursor-pointer"
				matInput
				readonly
				type="text"
			>
			<button
				(click)="$event.preventDefault(); $event.stopPropagation(); setProject()"
				*ngIf="group.value.project && !group.value.project?.useAsDefault"
				mat-icon-button
				matSuffix
				type="button"
			>
				<mat-icon>clear</mat-icon>
			</button>
			<mat-hint>{{ 'time.bulk-hint-project' | translate }}</mat-hint>
		</mat-form-field>
		<ng-container *ngIf="{ disabled: group.value.project?.useAsDefault } as taskValid">
			<mat-form-field
				(click)="$event.preventDefault(); openTaskPicker()"
				[class.cursor-pointer]="!taskValid.disabled"
				appearance="fill"
			>
				<mat-label translate>Task</mat-label>
				<input
					[class.cursor-pointer]="!taskValid.disabled"
					[disabled]="taskValid.disabled"
					[value]="group.value.task?.name"
					matInput
					readonly
					type="text"
				>
				<button
					(click)="$event.preventDefault(); $event.stopPropagation(); setTask()"
					[disabled]="taskValid.disabled"
					*ngIf="group.value.task"
					mat-icon-button
					matSuffix
					type="button"
				>
					<mat-icon>clear</mat-icon>
				</button>
				<mat-hint>{{ 'time.bulk-hint-task' | translate }}</mat-hint>
			</mat-form-field>
		</ng-container>
		<div class="flex w-full flex-col">
			<mat-form-field
				appearance="fill"
				class="mb-4"
			>
				<mat-label>{{ 'tag.select' | translate }}</mat-label>
				<input
					(click)="$event.preventDefault(); this.openTagsPicker()"
					[value]="group.value.tags ?? [] | mapProp: 'name' | joinString: ', '"
					class="cursor-pointer"
					matInput
					readonly
					type="text"
				>
				<button
					(click)="$event.preventDefault(); $event.stopPropagation(); group.patchValue({ tags: [] })"
					*ngIf="group.value.tags?.length > 0"
					mat-icon-button
					matSuffix
					type="button"
				>
					<mat-icon>clear</mat-icon>
				</button>
				<mat-hint>{{ 'time.bulk-hint-tags' | translate }}</mat-hint>
			</mat-form-field>
			<mat-checkbox
				class="text-sm"
				color="primary"
				formControlName="replaceTags"
			>
				{{ 'time.bulk-hint-tags-replace' | translate }}
			</mat-checkbox>
		</div>
		<div
			(click)="$event.preventDefault(); openUserPicker()"
			[class.cursor-pointer]="workspace$isAdmin.value"
			class="flex w-full flex-col"
		>
			<mat-form-field
				appearance="fill"
				class="form-control-interactive"
			>
				<mat-label>{{ 'user.select' | translate }}</mat-label>
				<div
					*ngIf="group.value.user as user"
					class="-mb-16px mt-2 flex items-center space-x-1.5"
				>
					<app-user-avatar
						[userId]="user.id"
						class="rounded-full"
						size="40px"
					></app-user-avatar>
					<div class="flex flex-auto flex-col leading-none">
						<span>{{ user.name }}</span>
						<span class="mat-hint text-sm">{{ user.email }}</span>
					</div>
					<button
						(click)="$event.preventDefault(); $event.stopPropagation(); group.patchValue({ user: null })"
						[disabled]="!workspace$isAdmin.value"
						*ngIf="group.value.user"
						mat-icon-button
					>
						<mat-icon>clear</mat-icon>
					</button>
				</div>
				<input
					[disabled]="!workspace$isAdmin.value"
					[value]="group.value.user"
					class="!pointer-events-none"
					matInput
					readonly
				>
				<mat-hint>{{ 'time.bulk-hint-user' | translate }}</mat-hint>
			</mat-form-field>
		</div>
		<!-- spacer -->
		<div>
			<div
				[class.toggle-card-active]="!group.value.preserveTime && showPreserveToggle"
				[class.toggle-card]="showPreserveToggle"
				class="mt-2 flex flex-col"
			>
				<mat-slide-toggle
					class="mat-slide-toggle-flex h-10 w-full"
					color="primary"
					formControlName="preserveTime"
					labelPosition="before"
				>
					<div class="flex flex-col"><span>{{ 'time.bulk-mixed-time' | translate }}</span></div>
				</mat-slide-toggle>
				<div
					*ngIf="!group.value.preserveTime"
					class="flex flex-col"
				>
					<div class="flex items-center space-x-2">
						<ng-container
							*ngTemplateOutlet="
                mode === 'range'
                  ? rangeModeTemplate
                  : mode === 'range_optional'
                    ? stateVisibleMode
                      ? rangeModeTemplate
                      : durationModeTemplate
                    : mode === 'duration'
                      ? durationModeTemplate
                      : null
              "
						></ng-container>
						<ng-container *ngIf="mode === 'range_optional'">
							<button
								(click)="stateVisibleMode = !stateVisibleMode"
								[matTooltip]="'timer.time.changeInputMode' | translate"
								[matTooltipOptions]="{ hideOnClick: false }"
								mat-icon-button
								type="button"
							>
								<mat-icon>swap_horiz</mat-icon>
							</button>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
		<mat-form-field appearance="fill">
			<mat-label>{{ 'timer.date' | translate }}</mat-label>
			<!-- <input
        matInput
        [matDatepicker]="picker"
        formControlName="date"
        [max]="settings$allowFutureTimeTracking | async"
        [min]="minDate()"
      /> -->
			<input
				[matDatepicker]="picker"
				[max]="maxDate()"
				[min]="minDate()"
				formControlName="date"
				matInput
			>
			<mat-hint>{{ 'time.bulk-hint-date' | translate }}</mat-hint>
			<mat-datepicker-toggle
				[for]="picker"
				matSuffix
			></mat-datepicker-toggle>
			<mat-datepicker
				[touchUi]="this.isMobile"
				#picker
			></mat-datepicker>
		</mat-form-field>
		<div
			[class.toggle-card-active]="!group.value.preserveBillable && showPreserveToggle"
			[class.toggle-card]="showPreserveToggle"
			class="flex flex-col"
		>
			<mat-slide-toggle
				class="mat-slide-toggle-flex h-10 w-full"
				color="primary"
				formControlName="preserveBillable"
				labelPosition="before"
			>
				<div class="flex flex-col"><span>{{ 'time.bulk-mixed-billable' | translate }}</span></div>
			</mat-slide-toggle>
			<div
				*ngIf="!group.value.preserveBillable"
				class="mb-2 mt-3"
			>
				<mat-checkbox
					(change)="group.patchValue({ billable: $event.checked })"
					[checked]="group.value.billable"
					color="primary"
				>
					{{ 'time.billability' | translate }}
				</mat-checkbox>
			</div>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		(click)="submit()"
		[disabled]="isLoading || group?.invalid || group?.disabled || !canEdit"
		color="primary"
		mat-raised-button
	>
		<span
			*ngIf="!isLoading; else showSaveLoading"
			translate
			>utils.save</span
		>
	</button>
</mat-dialog-actions>
<ng-template #showSaveLoading>
	<div class="flex flex-row items-center justify-center">
		<mat-progress-spinner
			[diameter]="16"
			[mode]="'indeterminate'"
			[strokeWidth]="2"
		></mat-progress-spinner>
		&nbsp;
	</div>
</ng-template>
<ng-template #rangeModeTemplate>
	<ng-container [formGroup]="group">
		<div class="flex flex-1 flex-col">
			<div class="flex flex-row items-center justify-between">
				<app-time-input
					[displayFormat]="false"
					[inputPlaceholder]="'timer.time.start' | translate"
					[maxlength]="5"
					class="wflex-[0_0_144px]"
					formControlName="start"
				>
					<ng-template
						let-control="control"
						let-inputPlaceholder="inputPlaceholder"
						timeInputControl
					>
						<mat-form-field
							appearance="fill"
							class="mat-form-field-no-hint"
							fxFill
						>
							<mat-label translate>timer.time.start</mat-label>
							<input
								[formControl]="control"
								[placeholder]="inputPlaceholder"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</app-time-input>
				<span class="tg-seperator mx-2"> <mat-icon>arrow_forward</mat-icon> </span>
				<app-time-input
					[displayFormat]="false"
					[inputPlaceholder]="'timer.time.end' | translate"
					[maxlength]="5"
					class="wflex-[0_0_144px]"
					formControlName="end"
				>
					<ng-template
						let-control="control"
						let-inputPlaceholder="inputPlaceholder"
						timeInputControl
					>
						<mat-form-field
							appearance="fill"
							class="mat-form-field-no-hint"
							fxFill
						>
							<mat-label translate>timer.time.end</mat-label>
							<input
								[formControl]="control"
								[placeholder]="inputPlaceholder"
								matInput
								type="text"
							>
						</mat-form-field>
					</ng-template>
				</app-time-input>
			</div>
		</div>
	</ng-container>
</ng-template>
<ng-template #durationModeTemplate>
	<div class="flex flex-1 flex-col">
		<ng-container [formGroup]="group">
			<tg-duration-input-control
				displayFormat="HH:mm"
				formControlName="duration"
			>
				<ng-template
					durationInputControl
					let-control="control"
					let-inputPlaceholder="inputPlaceholder"
					let-name="name"
				>
					<mat-form-field
						appearance="fill"
						class="mat-form-field-no-hint"
						fxFill
					>
						<mat-label translate>timer.time.duration</mat-label>
						<input
							[formControl]="control"
							matInput
							type="text"
						>
					</mat-form-field>
				</ng-template>
			</tg-duration-input-control>
		</ng-container>
	</div>
</ng-template>
